import { Translations } from '../types/localization.types';

/**
 * Dutch translations for PDF Form Designer
 */
export const nl: Translations = {
  elements: {
    textInput: 'Tekstinvoer',
    radioButton: 'Keuzerondje',
    checkbox: 'Selectievakje',
    signature: 'Handtekening',
    digitalSignature: 'Digitale Handtekening',
    biometricSignature: 'Biometrische Handtekening',
    initials: 'Initialen',
    text: 'Tekst',
    attachmentsList: 'Bijlagenlijst'
  },

  buttons: {
    save: 'Wijzigingen Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    deleteAll: 'Alle Initialen Verwijderen',
    addToOtherPages: 'Toevoegen aan Andere Pagina\'s',
    clearAll: 'Alles Wissen',
    edit: 'Bewerken'
  },

  modal: {
    editElement: '{type} Element Bewerken',
    properties: 'Eigenschappen'
  },

  fields: {
    name: 'Naam',
    readOnly: 'Alleen Lezen',
    required: 'Verplicht',
    placeholder: 'Tijdelijke Aanduiding',
    defaultValue: 'Standaardwaarde',
    fontSize: 'Lettergrootte',
    fontFamily: 'Lettertype',
    fontWeight: 'Letterdikte',
    textColor: 'Tekstkleur',
    backgroundColor: 'Achtergrondkleur',
    borderColor: 'Randkleur',
    borderWidth: 'Randbreedte',
    groupName: 'Groepsnaam',
    value: 'Waarde',
    selectedValue: 'Geselecteerde Waarde',
    label: 'Label',
    checked: 'Aangevinkt',
    buttonColor: 'Knopkleur',
    checkColor: 'Vinkkleur',
    text: 'Tekst',
    textAlign: 'Tekstuitlijning',
    angle: 'Hoek (graden)',
    italic: 'Cursief',
    underline: 'Onderstreept',
    bold: 'Vet',
    normal: 'Normaal',
    lighter: 'Lichter',
    left: 'Links',
    center: 'Centreren',
    right: 'Rechts',
    signatureMethod: 'Handtekening Methode',
    certificateInfo: 'Certificaat Info',
    timestampRequired: 'Tijdstempel Vereist',
    deviceInfo: 'Apparaat Info',
    pressureSensitive: 'Drukgevoelig',
    velocityTracking: 'Snelheid Volgen',
    distanceFromRight: 'Afstand vanaf de Rechterkant (PDF punten)',
    distanceFromBottom: 'Afstand vanaf de Onderkant (PDF punten)',
    // Attachments list specific fields
    listDisplay: 'Lijstweergave',
    showFileNames: 'Toon Bestandsnamen',
    showFileSizes: 'Toon Bestandsgroottes',
    listStyle: 'Lijststijl',
    listStyleNone: 'Geen (Normaal)',
    listStyleNumbers: 'Nummers (1, 2, 3)',
    textFormatting: 'Tekstopmaak',
    spacingLayout: 'Spatiëring en Lay-out',
    lineHeight: 'Regelhoogte',
    lineHeightHelp: 'Spatiëringsmultiplicator (1.0 = strak, 2.0 = dubbele afstand)',
    indentation: 'Inspringing (punten)',
    indentationHelp: 'Linker inspringing voor elke bijlageregel',
    styling: 'Visuele Styling'
  },

  signatureMethods: {
    pki: 'PKI Certificaat',
    adobe: 'Adobe Sign',
    docusign: 'DocuSign'
  },

  signers: {
    title: 'Ondertekenaars',
    noSigners: 'Nog geen ondertekenaars toegevoegd.',
    addSignersMessage: 'Voeg extern ondertekenaars toe om formulierelementen in te schakelen.',
    activeIndicator: 'Actief',
    clickToActivate: 'Klik om te activeren'
  },

  tooltips: {
    disabled: '(Uitgeschakeld)',
    deleteElement: 'Element verwijderen',
    editElement: 'Element eigenschappen bewerken',
    placeElement: 'Klik op PDF om element te plaatsen',
    fontSize: 'Lettergrootte',
    fontFamily: 'Lettertype',
    textColor: 'Tekstkleur',
    italic: 'Cursief',
    underline: 'Onderstreept'
  },

  dialogs: {
    switchSignerConfirm: 'Dit element behoort tot {name} ({email}). Wilt u overschakelen naar deze ondertekenaar?'
  },

  placeholders: {
    enterText: 'Voer tekst in...',
    certificateDetails: 'Certificaat details',
    deviceInfo: 'Opname apparaat informatie',
    abc: 'ABC',
    textInput: 'Tekstinvoer',
    signature: 'Handtekening',
    digitalSignature: 'Digitale Handtekening',
    text: 'Tekst',
    attachmentsList: 'Bijlagenlijst',
    attachmentsCapacity: '({count} bijlage(n) passen)'
  },

  fonts: {
    arial: 'Arial',
    timesNewRoman: 'Times New Roman',
    helvetica: 'Helvetica',
    courier: 'Courier'
  },

  errors: {
    elementNameEmpty: 'Elementnaam mag niet leeg zijn',
    elementNameDuplicate: 'Elementnaam "{name}" wordt al gebruikt door een ander element. Namen moeten wereldwijd uniek zijn.',
    selectedValueEmpty: 'Geselecteerde waarde mag niet leeg zijn',
    selectedValueDuplicate: 'Dubbele optiewaarde "{value}" bestaat al in groep "{group}"',
    radioGroupNameConflict: 'Keuzerondjegroepnaam "{name}" wordt al gebruikt door een andere ondertekenaar. Elke ondertekenaar moet unieke groepsnamen hebben.',
    invalidConfigVersion: 'Ongeldige configuratie: Alleen versie 3.0.0 wordt ondersteund. Zorg ervoor dat uw configuratie exacte coördinaten met paginadimensies gebruikt.',
    noSignersInConfig: 'Ongeldige configuratie: Geen ondertekenaars gevonden. Alle configuraties moeten ten minste één ondertekenaar bevatten.',
    noActiveSignerInConfig: 'Ongeldige configuratie: Geen actieve ondertekenaar opgegeven.',
    activeSignerNotInList: 'Ongeldige configuratie: Actieve ondertekenaar-ID bestaat niet in de ondertekenaarslijst.',
    elementsWithoutSigner: 'Ongeldige configuratie: {count} elementen gevonden zonder ondertekenaartoewijzing.',
    elementsReferenceInvalidSigners: 'Ongeldige configuratie: {count} elementen verwijzen naar ondertekenaars die niet bestaan.',
    partialConfigMissingSigners: 'Configuratie gedeeltelijk geladen. Voeg de volgende ondertekenaars toe om het laden te voltooien:\n{signerIds}',
    invalidElementDimensions: 'Waarschuwing: Configuratie bevat {count} element(en) met ongeldige afmetingen (ondersteboven): {ids}. Deze zijn automatisch gecorrigeerd.',
    zeroSizedElements: 'Ongeldige configuratie: {count} element(en) hebben nul afmetingen en kunnen niet worden weergegeven.'
  }
};